import { render, staticRenderFns } from "./Sk7mobile.vue?vue&type=template&id=1a722334&scoped=true"
import script from "./Sk7mobile.vue?vue&type=script&lang=js"
export * from "./Sk7mobile.vue?vue&type=script&lang=js"
import style0 from "./Sk7mobile.vue?vue&type=style&index=0&id=1a722334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a722334",
  null
  
)

export default component.exports